"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

require("font-awesome/css/font-awesome.min.css");

var _flow = _interopRequireDefault(require("lodash/flow"));

var _reactDnd = require("react-dnd");

var _ = require("../..");

var s = _interopRequireWildcard(require("./Row.style"));

var _Cell = _interopRequireDefault(require("../Cell/Cell"));

var _propTypes2 = require("../propTypes");

var _isFirstDataColumn = _interopRequireDefault(require("../utils/isFirstDataColumn"));

var _hasChildren = _interopRequireDefault(require("../utils/hasChildren"));

var Types = {
  MOVEROW: 'moveRow'
};
var rowSource = {
  beginDrag: function beginDrag(props, monitor, component) {
    // console.log(props);
    // console.log(monitor);
    console.log('From Begin ' + props.rowIndex);
    return {
      index: props.rowIndex
    };
  }
};
var rowTarget = {
  hover: function hover(props, monitor, component) {
    var dragIndex = monitor.getItem().index;
    var dropIndex = props.rowIndex;
    console.log('hovering!');

    if (dragIndex === dropIndex) {
      return;
    }

    var hoverBoundingRect = _reactDom.default.findDOMNode(component).getBoundingClientRect();

    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    var clientOffset = monitor.getClientOffset();
    var hoverClientY = clientOffset.y - hoverBoundingRect.top;

    if (dragIndex < dropIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    if (dragIndex > dropIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    props.onDrop(dragIndex, dropIndex);
    monitor.getItem().index = dropIndex; // console.log('From Hover  ' +dropIndex)
  },
  drop: function drop(props, monitor) {
    var dragIndex = monitor.getItem().index;
    var dropIndex = props.rowIndex; // if (dropIndex === dragIndex) { return; }

    props.onDrop(dragIndex, dropIndex, true);
    monitor.getItem().index = dropIndex;
    console.log('from Drop ' + dropIndex);
  }
};

var Row =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Row, _PureComponent);

  function Row() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Row);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Row)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderExpandButton", function (columnKey, rowData, draggable, connectDragSource, setIcon) {
      var _this$props = _this.props,
          isAnyRowExpandable = _this$props.isAnyRowExpandable,
          columns = _this$props.columns,
          isExpanded = _this$props.isExpanded,
          onToggleExpand = _this$props.onToggleExpand;
      var isFirst = (0, _isFirstDataColumn.default)(columnKey, columns);
      var childrenExists = (0, _hasChildren.default)(rowData);

      if (draggable && isFirst) {
        if (childrenExists) {
          return _react.default.createElement("div", null, connectDragSource(_react.default.createElement("i", {
            className: s.expandButton + ' fa fa-bars',
            style: {
              color: '#4a90e2'
            }
          })), _react.default.createElement(_.AccentButton, {
            icon: {
              type: isExpanded ? 'minus' : 'plus'
            },
            className: s.expandButton,
            onClick: onToggleExpand
          }));
        }

        return connectDragSource(_react.default.createElement("div", {
          style: {
            marginRight: setIcon ? '24px' : '0px'
          }
        }, _react.default.createElement("div", {
          className: s.root(_this.props.theme)
        }, _react.default.createElement("div", null), _react.default.createElement("div", null), _react.default.createElement("div", null), _react.default.createElement("div", null), _react.default.createElement("div", null), _react.default.createElement("div", null))));
      }

      if (!isAnyRowExpandable) {
        return null;
      }

      if (isFirst) {
        if (childrenExists) {
          return _react.default.createElement("div", null, _react.default.createElement(_.AccentButton, {
            icon: {
              type: isExpanded ? 'minus' : 'plus'
            },
            className: s.expandButton,
            onClick: onToggleExpand
          }));
        }

        return _react.default.createElement("span", {
          style: {
            width: '14px'
          },
          className: s.expandButton
        });
      }

      return null;
    });
    return _this;
  }

  (0, _createClass2.default)(Row, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          theme = _this$props2.theme,
          rowData = _this$props2.rowData,
          columns = _this$props2.columns,
          connectDragSource = _this$props2.connectDragSource,
          connectDropTarget = _this$props2.connectDropTarget,
          connectDragPreview = _this$props2.connectDragPreview,
          isDragging = _this$props2.isDragging,
          onRowClick = _this$props2.onRowClick,
          rowHeight = _this$props2.rowHeight,
          rowIndex = _this$props2.rowIndex,
          handleRowHover = _this$props2.handleRowHover,
          isHovered = _this$props2.isHovered,
          indentLevel = _this$props2.indentLevel,
          isExpanded = _this$props2.isExpanded,
          draggable = _this$props2.draggable,
          setIcon = _this$props2.setIcon;
      var opacity = isDragging ? 0.5 : 1;

      if (draggable) {
        return connectDragPreview(connectDropTarget(_react.default.createElement("tr", {
          style: {
            opacity: opacity
          },
          className: s.rowStyle(theme, onRowClick, isHovered),
          onClick: function onClick(e) {
            return onRowClick && onRowClick(e, rowData);
          },
          onMouseEnter: function onMouseEnter() {
            return handleRowHover(rowData.__key);
          }
        }, columns.map(function (col) {
          return _react.default.createElement(_Cell.default, {
            rowData: rowData,
            key: col.key,
            col: col,
            index: rowIndex,
            rowHeight: rowHeight,
            columns: columns,
            indentLevel: (0, _isFirstDataColumn.default)(col.key, columns) ? indentLevel : 0,
            isExpanded: isExpanded,
            draggable: draggable,
            expandButton: _this2.renderExpandButton(col.key, rowData, draggable, connectDragSource, setIcon)
          });
        }))));
      }

      return _react.default.createElement("tr", {
        className: s.rowStyle(theme, onRowClick, isHovered),
        onClick: function onClick(e) {
          return onRowClick && onRowClick(e, rowData);
        },
        onMouseEnter: function onMouseEnter() {
          return handleRowHover(rowData.__key);
        }
      }, columns.map(function (col) {
        return _react.default.createElement(_Cell.default, {
          rowData: rowData,
          key: col.key,
          col: col,
          index: rowIndex,
          rowHeight: rowHeight,
          columns: columns,
          indentLevel: (0, _isFirstDataColumn.default)(col.key, columns) ? indentLevel : 0,
          isExpanded: isExpanded,
          draggable: draggable,
          expandButton: _this2.renderExpandButton(col.key, rowData, draggable, connectDragSource, setIcon)
        });
      }));
    }
  }]);
  return Row;
}(_react.PureComponent);

Row.propTypes = {
  theme: _propTypes.default.shape({}).isRequired,
  columns: _propTypes.default.arrayOf(_propTypes2.columnPropType).isRequired,
  rowHeight: _propTypes.default.number,
  rowIndex: _propTypes.default.number,
  rowData: _propTypes2.rowPropType.isRequired,
  connectDragSource: _propTypes.default.func.isRequired,
  connectDropTarget: _propTypes.default.func.isRequired,
  onDrop: _propTypes.default.func.isRequired,
  onRowClick: _propTypes.default.func,
  handleRowHover: _propTypes.default.func.isRequired,
  isHovered: _propTypes.default.bool.isRequired,
  indentLevel: _propTypes.default.number.isRequired,
  isAnyRowExpandable: _propTypes.default.bool.isRequired,
  isExpanded: _propTypes.default.bool.isRequired,
  draggable: _propTypes.default.bool.isRequired,
  setIcon: _propTypes.default.bool,
  onToggleExpand: _propTypes.default.func.isRequired
};
var Demo = (0, _emotionTheming.withTheme)(Row);

var _default = (0, _flow.default)((0, _reactDnd.DragSource)(Types.MOVEROW, rowSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}), (0, _reactDnd.DropTarget)(Types.MOVEROW, rowTarget, function (connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    hovered: monitor.isOver()
  };
}))(Demo);

exports.default = _default;